module.exports = __webpack_public_path__ + "img/optometry_parameters.554e27e9.svg";